import React, { forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";

export interface LinkOrSpanProps extends Omit<LinkProps, "to"> {
  to?: LinkProps["to"];
  children: React.ReactNode;
}

const LinkOrSpan = forwardRef<HTMLAnchorElement | HTMLSpanElement, LinkOrSpanProps>(
  ({ children, target, to, ...props }, ref) => {
    if (to) {
      return (
        <Link
          target={target}
          to={to}
          {...props}
          ref={ref as React.Ref<HTMLAnchorElement>}
        >
          {children}
        </Link>
      );
    }

    return (
      <span
        {...props}
        ref={ref as React.Ref<HTMLSpanElement>}
      >
        {children}
      </span>
    );
  }
);

export default LinkOrSpan;
